import CurrencyInput from "./CurrencyInput";
import NumberInput from "./NumberInput";
import PercentageInput from "./PercentageInput";
import SelectInput from "./SelectInput";
import ArrayInput from "./ArrayInput";

import { FIELD_TYPES } from "@/utils/calculatorSchema";

export const FIELD_RENDERERS = {
  [FIELD_TYPES.CURRENCY]: CurrencyInput,

  [FIELD_TYPES.NUMBER]: NumberInput,

  [FIELD_TYPES.PERCENT]: PercentageInput,

  [FIELD_TYPES.SELECT]: SelectInput,

  [FIELD_TYPES.ARRAY]: ArrayInput,
};